export const subtitles = {
    "1": {
        "startTime": 0.0,
        "endTime": 2.67,
        "transcript": "...as soon as we got here. Tua-i-qaa ready?",
        "translation": "...as soon as we got here. So are you ready?"
    },
    "2": {
        "startTime": 14.56,
        "endTime": 18.19,
        "transcript": "Okay, ii-i. Nangeq waniwa apyutka.",
        "translation": "Okay, okay. Here's my last question."
    },
    "3": {
        "startTime": 19.61,
        "endTime": 25.67,
        "transcript": "Man'a-qaa Yugcetun qalarcaraput",
        "translation": "Is our Yup'ik language"
    },
    "4": {
        "startTime": 26.795,
        "endTime": 31.755,
        "transcript": "Tua-i-w' qalarcaraput Yugcetun. Waniw' watuarpak qalartellriakut Yugcetun.",
        "translation": "Well, our Yup'ik language. We've been speaking Yup'ik now."
    },
    "5": {
        "startTime": 31.91,
        "endTime": 38.75,
        "transcript": "Man'a-qaa elpeni makunun ayagyuanun nalluyagutnarqenrituq, ciin-llu?",
        "translation": "To you, should the young people not forget it, and why?"
    },
    "6": {
        "startTime": 39.465,
        "endTime": 41.785,
        "transcript": "Nalluyagutnarqenrituq.",
        "translation": "It should not be forgotten."
    },
    "7": {
        "startTime": 43.82,
        "endTime": 57.41,
        "transcript": "Pitsaqa'artevkenani waten arnassagaurquralriamek wall' temyigilriamek nallarkengkuni qanerteryugyuartuq tauna yuk.",
        "translation": "If that person by chance comes across an old woman or an elder, he might need someone to speak for him."
    },
    "8": {
        "startTime": 58.69,
        "endTime": 70.79,
        "transcript": "Waten taum yuum nallunrilkuni wangkucicetun qallacaraput, Kass'acetun-llu qallacaraput tua-i tauna ikayuutnguqapiartuq qanerluni.",
        "translation": "If a person knows our language, and the English language, it is of great help to speak them."
    },
    "9": {
        "startTime": 71.87,
        "endTime": 78.43,
        "transcript": "Atam ukut tutgara'urluunka Kass'amek atangqerrsaaqut.",
        "translation": "You see, my grandchildren have a Caucasian father."
    },
    "10": {
        "startTime": 79.26,
        "endTime": 84.06,
        "transcript": "Qitevpallu'urturluteng tau͡gaam Yugtun nallunritut.",
        "translation": "They  mostly speak English, but they know Yup'ik."
    },
    "11": {
        "startTime": 84.47,
        "endTime": 88.19,
        "transcript": "Ugkut Elizabeth Howard-aam yui, taukut.",
        "translation": "Elizabeth Howard's children downriver."
    },
    "12": {
        "startTime": 88.82,
        "endTime": 94.3,
        "transcript": "Qanerteńguaqluteng-llu-gguq nani tua-i piaqameng arenqialluga'artellriamun.",
        "translation": "They also help with communication to someone who comes to misfortune somewhere."
    },
    "13": {
        "startTime": 96.29,
        "endTime": 101.81,
        "transcript": "Tau͡gaam pikagtellermeggnun naggluteng Yugtun qanerpakayuitut.",
        "translation": "But since they are so hindered by k/q and r/g distinctions, they don't speak much Yup'ik."
    },
    "14": {
        "startTime": 105.36,
        "endTime": 113.3,
        "transcript": "Ca, man'a wangkucicetun qaneryararput cagmarnarqenrituq.",
        "translation": "Um, we should not lose our language."
    },
    "15": {
        "startTime": 115.15,
        "endTime": 123.49,
        "transcript": "Kass'acetun wangkucicetun pitateklukek taringumalukek pikuni piluaqerciquq.",
        "translation": "One will do well if he equally understand English and our langauge."
    },
    "16": {
        "startTime": 123.71,
        "endTime": 132.23,
        "transcript": "Wavet Kass'anun piaqami ellaicecitun qallataqluni, wavet yum'inun ellaicecitun qallataqluni.",
        "translation": "When he goes among Caucasians, he can speak like them, then when he goes to his own people, he can speak like them."
    },
    "17": {
        "startTime": 132.93,
        "endTime": 136.88,
        "transcript": "Nutaan tuani assirciquq tuaten pugtatateklukek.",
        "translation": "It will be well to have them equally like that."
    },
    "18": {
        "startTime": 138.8,
        "endTime": 144.1,
        "transcript": "Ilait... I swear, last question. Tua-i nangneqapiar waniwa.",
        "translation": "Some... I swear, last question. This is the very last one."
    },
    "19": {
        "startTime": 144.1,
        "endTime": 156.65,
        "transcript": "Ilait Kass'at waten qantuut: taukut-gguq yuut quyungqalriit tua-i yug'uluteng ellaicecitun-llu allataunateng ellarpiim iluani.",
        "translation": "Some Caucasians say this: those people gathered there who are indigenous, there is no one else in the world like them."
    },
    "20": {
        "startTime": 156.65,
        "endTime": 163.42,
        "transcript": "Ellait kiimeng yug'uluteng, piciryarateng-llu ellait kiimeng pikluku. Allat-llu piciryaraicetun piinanateng.",
        "translation": "They are the only people like them, and their culture is unique to them. And no other has a culture like them."
    },
    "21": {
        "startTime": 163.85,
        "endTime": 170.61,
        "transcript": "Tua-i-llu-gguq qaneryarateng cagmaamegteggu tua-i tayimqerrluteng. Saagartellriatun-gguq tua-i.",
        "translation": "And then they say that when they lost their langauge, they disappeared. It was like they were scattered."
    },
    "22": {
        "startTime": 171.32,
        "endTime": 183.16,
        "transcript": "Elpeni-qaa man'a wangkuta Yugni qaneryaraput cagmaqumteggu saagartellriatun iqukliciiqukut? (Yaa.) Yuk piunrirciquq?",
        "translation": "To you, if we lose our Yup'ik language, will we go extinct as if we were scattered? (Yes.) Will there be no more Yupiit?"
    },
    "23": {
        "startTime": 183.56,
        "endTime": 188.35,
        "transcript": "Yaa, tuaten piciqukut taringutesciigali'irrluta.",
        "translation": "Yes, we will do that, becoming unable to understand each other."
    },
    "24": {
        "startTime": 188.76,
        "endTime": 196.37,
        "transcript": "Una Yuk makut-llu ciuliaput qitevpakayuilnguut, Yugturpalluq tau͡gaam.",
        "translation": "A Yup'ik here and our ancestors didn't speak much of anything else, only mostly Yup'ik."
    },
    "25": {
        "startTime": 196.96,
        "endTime": 205.85,
        "transcript": "Tua-i-llu ukuk nalluyaguskuniu Yugtaam Yupiayagaunge'rmi ava-i qanrutellruamken.",
        "translation": "And then if a little Yup'ik forgets these Yup'ik things, I just told you about it."
    },
    "26": {
        "startTime": 206.25,
        "endTime": 219.4,
        "transcript": "Ilaitni wani inerquigaqama waten, waten wangkucicetun qalarulluki imkut Yupiayagaat, waten kiularaatnga: \"Taringenritamken.\"",
        "translation": "Somtimes, when I admonish these little Yupiit speaking in our language, they answer me like this: \"I don't understand you.\""
    },
    "27": {
        "startTime": 222.98,
        "endTime": 229.24,
        "transcript": "Amta-llu Yupiayaaruluteng, wangkucicetun-llu qalarulluki inerqurluki.",
        "translation": "And yet they are little Yupiit, and I speak admonishments to them in our language."
    },
    "28": {
        "startTime": 230.85,
        "endTime": 244.35,
        "transcript": "Ilaita-llu, ilaita qanernaurtut, \"Kalikamteńi tamana igausnganrituq,\" makut wangkuta piciryaraput piaqamteki, nalqigtaqamteki.",
        "translation": "And some would say, \"That's not written in our textbooks,\" when we explain our culture to them."
    },
    "29": {
        "startTime": 249.28,
        "endTime": 253.53,
        "transcript": "Makunun high school-am kalikainun ingluangluteng.",
        "translation": "They've started leaning to these high school textbooks."
    },
    "30": {
        "startTime": 259.54,
        "endTime": 265.7,
        "transcript": "Tua-i-wa. (Ii-i.) Quyanaqvaa. (Aa-ang, ii-i.) Ii-i, quyanaqvaa cakneq. (Kitaki.)",
        "translation": "That's all. (Okay.) Thank you very much. (Yes, you're welcome.) Yes, thank you very much. (There you go.)"
    },
    "31": {
        "startTime": 273.26,
        "endTime": 277.53,
        "transcript": "(Yaa-i tang.) [?]-llam tailuni. Taiyukuvet tai-tai.",
        "translation": "(He's over there.) [?] is coming. Come if you want to."
    },
    "32": {
        "startTime": 277.83,
        "endTime": 279.19,
        "transcript": "Tai-tai maaggun.",
        "translation": "Come through here."
    },
    "33": {
        "startTime": 296.52,
        "endTime": 298.64,
        "transcript": "Ready? (Yaa.) Okay.",
        "translation": "Ready? (Yes.) Okay."
    },
    "34": {
        "startTime": 299.38,
        "endTime": 300.46,
        "transcript": "Ii-i.",
        "translation": "Okay."
    },
    "35": {
        "startTime": 301.42,
        "endTime": 310.41,
        "transcript": "Tua-ll' makut ak'allaat Yuut qanruyutait, qanruyutek'lallrit-llu ak'a tamaanillaat piciatun",
        "translation": "And so, the ancient Yup'ik wisdom, and the various ancient traditional wisdom from back then"
    },
    "36": {
        "startTime": 313.23,
        "endTime": 325.26,
        "transcript": "Taringeqarraallermeggni Yuut mat'umek Qaneryaramek, Bible-aamek naaqingqarraallermeggni taringengluku-llu",
        "translation": "When Yupiit first started understanding the Qaneryarat [Bible], and when they first read and understood the Bible"
    },
    "37": {
        "startTime": 327.46,
        "endTime": 338.48,
        "transcript": "Maaten-gguq ilait pilallruut tua-i-w' ayuqerrlugluteng. Tamana-qaa piciuguq?",
        "translation": "They said that some found that they were similar. Is that true?"
    },
    "38": {
        "startTime": 338.8,
        "endTime": 342.38,
        "transcript": "Yaa, tamana piciuguq qanlallrat.",
        "translation": "Yes, what they said is true."
    },
    "39": {
        "startTime": 342.4,
        "endTime": 349.0,
        "transcript": "Cali-ll' TV-tgun makutgun wiinga qanrutkaqatgu niitela'arqa.",
        "translation": "Also, when they speak out it through these TV's, I hear it."
    },
    "40": {
        "startTime": 349.77,
        "endTime": 353.82,
        "transcript": "Ak'anek ayagluni man'a qanruyun piuguq-gguq.",
        "translation": "They say that this wisdom is from long ago."
    },
    "41": {
        "startTime": 354.87,
        "endTime": 364.58,
        "transcript": "Tua-i-ll' cali avaggun cali ava-i Bible-aat imaitgun cali qanruyun cali piuluni.",
        "translation": "The wisdom is also present through what is in the Bible."
    },
    "42": {
        "startTime": 365.44,
        "endTime": 374.29,
        "transcript": "Waken ciuqliit au͡gkut ak'allaraat man'a qanruyun pikaat.",
        "translation": "From the ancient ancestors here, that wisdom is theirs."
    },
    "43": {
        "startTime": 374.83,
        "endTime": 388.39,
        "transcript": "Tua-i-llu pikngatgu makut wani Bible-aat maa-i alairata ak'allaraat tamaani qanlallrit elitaqaqluki.",
        "translation": "And because it was theirs, when these Bible appeared, we recognized what the old ones would say back then."
    },
    "44": {
        "startTime": 389.51,
        "endTime": 397.67,
        "transcript": "Tuar-gguq nalluvkenaki makut Bible-aat imaitnek qalartelalriit, inerquutekluki tua-i.",
        "translation": "They said that they would speak as if they knew about the Bible, even their admonishments."
    },
    "45": {
        "startTime": 397.78,
        "endTime": 404.41,
        "transcript": "Inerquun ak'a, ak'anek piuluni ayagluni tua-i piuguq ilumun.",
        "translation": "The admonishments have truly existed since ancient times."
    },
    "46": {
        "startTime": 404.52,
        "endTime": 407.2,
        "transcript": "(Cangallruvkenateng?) Cangallruvkenateng.",
        "translation": "(Are they no different?) They're no different."
    },
    "47": {
        "startTime": 407.81,
        "endTime": 415.99,
        "transcript": "Wiinga-llu mikcuaraulua maaten ellangua tua-i qanruyun niitaqluku.",
        "translation": "When I was small, I found growing up that we would listen to traditional wisdom."
    },
    "48": {
        "startTime": 416.61,
        "endTime": 425.49,
        "transcript": "Mikcuarauluta qasgimi im' qavalallemteńi angukara'urluut wangkuta qalarutetullruitkut.",
        "translation": "When we were small and slept in the community house, the old men would speak to us."
    },
    "49": {
        "startTime": 426.33,
        "endTime": 429.92,
        "transcript": "Allakaita-llu makut nasaurluut enemi. (Bike-an ayauteqatallia.)",
        "translation": "And the girls would be separate in the house. (He might take your bike.)"
    },
    "50": {
        "startTime": 431.16,
        "endTime": 435.81,
        "transcript": "Tuaten tua-i ayuqellruuq. (Bike-an aqvau. Aqvau bike-an.)",
        "translation": "That's how it was. (Get your bike. Get your bike.)"
    },
    "51": {
        "startTime": 435.81,
        "endTime": 445.87,
        "transcript": "Cali wangkuta tan'gaurlurni elluicaarpek'nata qavarcet'lallruitkut.",
        "translation": "Also, they wouldn't let us boys sleep too comfortably."
    },
    "52": {
        "startTime": 445.87,
        "endTime": 454.09,
        "transcript": "Wiinga-wa elliraungama angayuqaagka-llu tangvallrunrilamkek",
        "translation": "Because I'm an orphan and didn't watch my parents"
    },
    "53": {
        "startTime": 455.8,
        "endTime": 459.86,
        "transcript": "Tua-i aklungqerrutacirramtun pilallrulrianga.",
        "translation": "I would do with what little I had."
    },
    "54": {
        "startTime": 460.71,
        "endTime": 471.79,
        "transcript": "Qasgimi-ll' inartaqluta caranglluut can'get quyurqaarluki akitekluki, pilugullraagka tau͡gaam yuuqerlukek.",
        "translation": "And I would go to bed in the community house after gathering grass for a pillow, but would take off my skin boots."
    },
    "55": {
        "startTime": 472.65,
        "endTime": 482.1,
        "transcript": "Maa-i makut kinguqliit qanrutaqamteng tamatumek ayuqucillemnek asgurakelaryugnarqaatnga.",
        "translation": "Now, when I tell the next generation about what I was like, they probably doubt me."
    },
    "56": {
        "startTime": 483.39,
        "endTime": 494.32,
        "transcript": "Tau͡gam angukara'urluut waten pilallruatnga: \"Piinanerpeni pingnaqkuvet, pingnaqengkuvet tuaten ayuqngaituten.",
        "translation": "But the old men would say this to me: \"As you go, if you make your own living, you will not be like that."
    },
    "57": {
        "startTime": 494.83,
        "endTime": 498.08,
        "transcript": "\"Kingunren nalluyagutenrilkuvgu.\"",
        "translation": "\"If you do not forget where you came from.\""
    },
    "58": {
        "startTime": 499.12,
        "endTime": 502.42,
        "transcript": "Tua-i ilumun man'a maa-i piciuluni.",
        "translation": "This is indeed true."
    },
    "59": {
        "startTime": 503.02,
        "endTime": 511.24,
        "transcript": "Arnassagaat-llu waten ikayurqamteng akqaqlua. Ciunerkamnek cunaw' mat'umek maa-i.",
        "translation": "And when I helped the old women like this, they would promise me. Apparently, it was for what was my future now."
    },
    "60": {
        "startTime": 512.61,
        "endTime": 516.96,
        "transcript": "Tua-i-llu cali qanrutaqluta waten:",
        "translation": "And then, they would also tell me this:"
    },
    "61": {
        "startTime": 517.65,
        "endTime": 528.7,
        "transcript": "\"Piinanerpeni erneq aipiqerluku unguvakuvet, kinguliaraten,\" makut kinguqliit cunaw' maa-i piluki",
        "translation": "\"As you go, if you live to see another day, your descendants,\" it was apparently the next generations here"
    },
    "62": {
        "startTime": 529.17,
        "endTime": 532.09,
        "transcript": "Qalarutlerkait tekilluki.",
        "translation": "I would come to speak to them."
    },
    "63": {
        "startTime": 532.96,
        "endTime": 540.44,
        "transcript": "Wiinga cali qalarut'larciqniluki qanruyuteteng nalluyagutenrilkumki.",
        "translation": "They said I would also speak to them if I didn't forget their traditional wisdom."
    },
    "64": {
        "startTime": 541.17,
        "endTime": 550.21,
        "transcript": "Tua-i-w' maa-i waten ellinge'rma qanruyutait imkut ciuqliit igvarturluteng.",
        "translation": "Even though I have reached this age, the elders' traditional wisdom continues to appear."
    },
    "65": {
        "startTime": 551.24,
        "endTime": 559.05,
        "transcript": "Allamek qalarcuituq waten qalartellria yuk murilkurallemni, murilkuryaurcama.",
        "translation": "A person speaking like this does not speak of anything else in my observation, when I started being observant."
    },
    "66": {
        "startTime": 559.67,
        "endTime": 568.37,
        "transcript": "Yuk un' qalartelartuq yuum qanellra cangallruvkenani, allamek qanruyutetaunani.",
        "translation": "A person speaks of things that are no different from another, without any other traditional wisdom."
    },
    "67": {
        "startTime": 568.87,
        "endTime": 577.42,
        "transcript": "Cali waten up'nerkami, qanruyun cali waniw' piuguq, arnaunge'rmeng-llu qanrutkaqluku.",
        "translation": "Also, in the spring liek this, this traditional wisdom still exists, and even women talk about it."
    },
    "68": {
        "startTime": 578.25,
        "endTime": 587.92,
        "transcript": "Ayaruq una up'nerkami pegingasqenritaat snuukuungraan, wall' ikamrangraan, wall' piyuangraan.",
        "translation": "They told us never to be without a staff in spring even if we're traveling by snow machines, sleds, or walking."
    },
    "69": {
        "startTime": 588.39,
        "endTime": 596.73,
        "transcript": "Kiagmi-llu cali waten nunam qaingani cali ayakan cali ayaruq pegingasqevkenaku.",
        "translation": "And if one walks on the ground in the summer, they also said not to be without a staff."
    },
    "70": {
        "startTime": 597.64,
        "endTime": 607.7,
        "transcript": "Imkunun nunapiim qaingani tungulriit imkut uitalalriit nallunrilketen. Tamaa-i tamakut aarnarqelriit.",
        "translation": "You know of those black things that are on the tundra. Those are dangerous."
    },
    "71": {
        "startTime": 608.52,
        "endTime": 616.76,
        "transcript": "Tuavet yuk tuskuni, murugareskuni tegumiarilkuni camek tamarciquq.",
        "translation": "If a person steps there and is pulled down without holding anything, he will disappear."
    },
    "72": {
        "startTime": 617.21,
        "endTime": 626.07,
        "transcript": "Tau͡gken tegumiangqerkuni tamatum muriim tegumiaran anernera anirturciqaa.",
        "translation": "However, if he is holding something, that piece of wood he's holding will save his life."
    },
    "73": {
        "startTime": 626.86,
        "endTime": 629.75,
        "transcript": "Makut maa-i qanruyutek'lallrenka.",
        "translation": "This is the wisdom passed down to me."
    },
    "74": {
        "startTime": 631.73,
        "endTime": 643.4,
        "transcript": "Anagulluki cali makut kinguqliit pisqevkenaki, makut cali irniarit.",
        "translation": "They also told them not to be too excessive with their descendants, including their children."
    },
    "75": {
        "startTime": 644.34,
        "endTime": 647.68,
        "transcript": "Tamaa-i tamakut qanrutkelallruit.",
        "translation": "That's what they would speak of."
    },
    "76": {
        "startTime": 648.55,
        "endTime": 654.48,
        "transcript": "Wiinga maa-i tau͡gaam mat'um nalliini umyuaqengaqluki.",
        "translation": "But these days, I start remembering them."
    },
    "77": {
        "startTime": 654.57,
        "endTime": 661.77,
        "transcript": "Waten-llu qalarqura'arqama qanellrita ilait eneqangaqluki.",
        "translation": "And when I speak like this, I start remembering some of what they said."
    },
    "78": {
        "startTime": 666.16,
        "endTime": 670.52,
        "transcript": "Allamek-wa cali qanerkangqellilriaten, apyutkangqellilriaten.",
        "translation": "You probably have something else to say, or ask."
    },
    "79": {
        "startTime": 670.52,
        "endTime": 672.3,
        "transcript": "Lucy-wa apnaluku.",
        "translation": "I intended to ask Lucy."
    },
    "80": {
        "startTime": 673.96,
        "endTime": 683.24,
        "transcript": "Makut-qaa nasaurluut-llu arnat tegganrit qanruyucilallruit?",
        "translation": "Would the elder women also pass down traditional wisdom to girls?"
    },
    "81": {
        "startTime": 683.64,
        "endTime": 685.0,
        "transcript": "Yaa.",
        "translation": "Yes."
    },
    "82": {
        "startTime": 685.04,
        "endTime": 689.35,
        "transcript": "Im'u-wa, amaqlicuarqa Evan [Keggup'aq] nallunritan?",
        "translation": "Well, do you know my little older brother, Evan [Keggup'aq]?"
    },
    "83": {
        "startTime": 689.55,
        "endTime": 701.41,
        "transcript": "Yaa, taum aanallran qalaruqatullruakut canritlermini au͡gkunek qaneryaranek ayuqucirtuutnek-llu cali.",
        "translation": "Yes, his late mother would always speak to us about that traditional wisdom and instructions when she was alive."
    },
    "84": {
        "startTime": 701.84,
        "endTime": 707.39,
        "transcript": "Tuamta-ll' cali irniyaramek, cali-llu uingyaramek.",
        "translation": "And then about how to bear children, and how to have a husband."
    },
    "85": {
        "startTime": 707.39,
        "endTime": 717.33,
        "transcript": "Tua-i-ll' cali iralurcuuterluteng muriit imkut uivtanqeggluteng muragkun kapucarauluni.",
        "translation": "And then they also had wooden circular calanders that they would stick wood into."
    },
    "86": {
        "startTime": 717.45,
        "endTime": 724.13,
        "transcript": "Erenret tuani, erneq tua-i tuavet piaqan tauna nugtarrluku tuavet kaputaqluku.",
        "translation": "When the days, when the day reached that, they moved it and stuck it in there."
    },
    "87": {
        "startTime": 726.3,
        "endTime": 729.77,
        "transcript": "Cali qalarutaqluta.",
        "translation": "She would also teach us."
    },
    "88": {
        "startTime": 730.29,
        "endTime": 736.03,
        "transcript": "Aanamta qalarucuitellruakut wangkuta, qaillun-ggurrluk ayuqetullruami.",
        "translation": "Our mother wouldn't teach us because she was a little abnormal."
    },
    "89": {
        "startTime": 736.22,
        "endTime": 742.59,
        "transcript": "Tau͡gaam atamta qalarutaqluta makunek inerquutnek wall' qaneryaranek.",
        "translation": "However, our father would talk to us about these admonishments or traditional wisdom."
    },
    "90": {
        "startTime": 742.59,
        "endTime": 746.52,
        "transcript": "Wall'u pisqumanrilngurnek qalarutaqluta.",
        "translation": "Or, he would speak to us about what we shouldn't do."
    },
    "91": {
        "startTime": 746.52,
        "endTime": 752.62,
        "transcript": "Nayurpallulallrukeka-wa wiinga atavut takaqellrunrilamku.",
        "translation": "I would mostly be around our father because I wasn't reserved around him."
    },
    "92": {
        "startTime": 752.65,
        "endTime": 757.2,
        "transcript": "Ilama tau͡gken tua-i qanrutesciiganaku, wangkuta tau͡gaam.",
        "translation": "My relatives, however, could not speak to him, only us."
    },
    "93": {
        "startTime": 757.36,
        "endTime": 761.48,
        "transcript": "Charlie-llu wangkuk qalaruterpalluraqluku.",
        "translation": "Charlie and I would mostly speak to him."
    },
    "94": {
        "startTime": 761.48,
        "endTime": 769.94,
        "transcript": "Iliini-llu kiimetaqan wii aipiartura'aqluku aanavut ceńingqangraan yugni.",
        "translation": "And sometimes, when he was alone, I would be with him even though our mother was visiting someone else."
    },
    "95": {
        "startTime": 770.58,
        "endTime": 776.08,
        "transcript": "Iliini-ll' maligqaarluku uterrvikaqluku aipiararaqluku.",
        "translation": "And sometimes after going with her, I would go home to be with him,"
    },
    "96": {
        "startTime": 778.58,
        "endTime": 791.32,
        "transcript": "Elpeni-qaa, Lucy, makut Yuut qanruyutellrit mat'um nalliini nalluyagutenritnarqut?",
        "translation": "To you, Lucy, should we not forget the old Yup'ik wisdom today?"
    },
    "97": {
        "startTime": 791.32,
        "endTime": 801.72,
        "transcript": "Yaa, nalluyagutnaitut au͡gkut ak'allaraat qallatellrit waten ellinge'rmi, arnaurteng'e'rmi.",
        "translation": "Yes, we should not forget the what the old ones said even when reaching this age, becoming an old woman."
    },
    "98": {
        "startTime": 801.72,
        "endTime": 809.21,
        "transcript": "Cali ilait mikelnguut wiinga qalaruartelaranka inerqurluki-llu.",
        "translation": "Also, I speak to and admonish some of the children."
    },
    "99": {
        "startTime": 811.7,
        "endTime": 814.79,
        "transcript": "Henry cali elpet apluten cali au͡g'umek.",
        "translation": "Henry, I also ask you that question."
    },
    "100": {
        "startTime": 815.06,
        "endTime": 822.86,
        "transcript": "Ciin elpeni man'a Yuut piciryarallrat qanruyutait-llu nalluyagutenritnarqa?",
        "translation": "To you, why shouldn't we forget the traditional Yup'ik way of life and wisdom?"
    },
    "101": {
        "startTime": 825.88,
        "endTime": 836.59,
        "transcript": "Qanruyutait-wa Yuut nalluyagutnaitlinilria waten allakarrarmi yuungnaqengluni.",
        "translation": "One should not forget traditional Yup'ik wisdom, trying to live differently."
    },
    "102": {
        "startTime": 839.08,
        "endTime": 846.84,
        "transcript": "Au͡gkut ciulirneret qanruyukarait umyuaqsaraulliniut.",
        "translation": "It turns out we must remember the elders' traditional wisdom."
    },
    "103": {
        "startTime": 847.55,
        "endTime": 854.53,
        "transcript": "Wiinga umyuaqeksaitelallruyaaqanka tua-i-ll' imumi nulirturpailegma.",
        "translation": "I never used to remember them back before I took a wife."
    },
    "104": {
        "startTime": 855.37,
        "endTime": 864.61,
        "transcript": "Maa-i mat'um nalliini tuar tang caurarqama waten, caqcara'arqama-llu",
        "translation": "These days, it seems that when I do things like this, and when I do little things"
    },
    "105": {
        "startTime": 865.03,
        "endTime": 874.12,
        "transcript": "Waten-llu picurlagnarqelrianek pilua nuniini tarrataqama tamana call' tamaa-i umyuaqengaqluku.",
        "translation": "And when I walk around dangerous areas, I start to remember that."
    },
    "106": {
        "startTime": 877.11,
        "endTime": 885.85,
        "transcript": "Yuum qanruyutii ak'allaraam nalluyagutnaituq waten ellirluni.",
        "translation": "You should not forget ancient Yup'ik wisdom at this age."
    },
    "107": {
        "startTime": 886.66,
        "endTime": 898.37,
        "transcript": "Cali-ll' ilait waten qanlaryaaqut: makut wani ak'allaraat qalaruciyuirutniluki mat'um nalliini.",
        "translation": "Also, some say this: elders do not teach anymore these days."
    },
    "108": {
        "startTime": 899.25,
        "endTime": 909.62,
        "transcript": "Waten tau͡gaam qanrut'lallruatnga: piinanemni-gguq wiinga qalaruciyaurciiqua.",
        "translation": "However, they would tell me this: as I go, I will start teaching."
    },
    "109": {
        "startTime": 909.65,
        "endTime": 922.08,
        "transcript": "Maa-i-ll' mat'um nalliini tamana umyuaqelaamku makut kinguqliit wiinga qanruartelaranka inerquraqluki-llu.",
        "translation": "And because I remember that these days, I speak to and admonish these next generations."
    },
    "110": {
        "startTime": 922.08,
        "endTime": 927.62,
        "transcript": "Mat'umek-llu ayagayaram iquanek qanrutkaqluki.",
        "translation": "I also speak about how the effects of traveling."
    },
    "111": {
        "startTime": 928.77,
        "endTime": 939.94,
        "transcript": "Ilait-llu maa-i qanrut'lallma ikayuagaqlua, quyavikaqlua-ll' tamakunek, tamakunek qalartelallemnek.",
        "translation": "And now, some fo the ones I used to teach help me out, and they thank me for speaking about those."
    },
    "112": {
        "startTime": 941.06,
        "endTime": 953.2,
        "transcript": "Uumi-llam cali iliita au͡g'um taqnerurrluni-w' tan'gaurluum yaani apqaurturaqallruanga qaillun mat'um taangam ayuqucianek.",
        "translation": "And recently, one of the boys over there who's become an adult asked me what alcohol was like."
    },
    "113": {
        "startTime": 953.99,
        "endTime": 961.02,
        "transcript": "Tua-i-llu wii atullruamku nallunrilamku ayuqucillemnek qanrulluku.",
        "translation": "And since I had experienced it and know it, I told him what I was like."
    },
    "114": {
        "startTime": 962.01,
        "endTime": 971.15,
        "transcript": "Waten qanrutellruaqa: \"Wiinga mer'atullemni, nuqlitellruunga cakamnek.",
        "translation": "I told him this: \"When I was an alocholic, I didn't have much."
    },
    "115": {
        "startTime": 972.66,
        "endTime": 977.49,
        "transcript": "\"Tau͡gken maa-i mat'um nalliini menrilkurqurangengama",
        "translation": "\"However, since I have stayed away from alcohol these days"
    },
    "116": {
        "startTime": 979.13,
        "endTime": 987.16,
        "transcript": "\"Tuar tang makut wani cakanka paivngalriatun ayuqelalriit.",
        "translation": "\"It seems that these things I have are available."
    },
    "117": {
        "startTime": 987.16,
        "endTime": 992.73,
        "transcript": "\"Umyuangaqama-ll' tua-i camek tegullua akikamnek piaqlua.\"",
        "translation": "\"And when I think of something, I take some money and get it.\""
    },
    "118": {
        "startTime": 993.35,
        "endTime": 1002.99,
        "transcript": "Tuaten piurqan picurlautekvailgaku man'a taangaryaraq taqengnaquraasqelluku.",
        "translation": "I told him that if he does that, try to quit drinking alcohol before it brings misfortune upon him."
    },
    "119": {
        "startTime": 1004.01,
        "endTime": 1007.18,
        "transcript": "Quyaciqnilua tamana taqkaku.",
        "translation": "I told him I'd be thankful if he quit that."
    },
    "120": {
        "startTime": 1008.7,
        "endTime": 1015.7,
        "transcript": "Waten kinguliaraam apyutii kiunricunaituq.",
        "translation": "We shouldn't keep from answering a question from the next generation."
    },
    "121": {
        "startTime": 1016.16,
        "endTime": 1021.49,
        "transcript": "Tau͡gaam ciunerkaanek apertuagarulluku assinruuq.",
        "translation": "But it's better to keep teaching him about his future."
    },
    "122": {
        "startTime": 1023.02,
        "endTime": 1029.06,
        "transcript": "Cali-llu yaani qalaruciaqama high school-am iluani",
        "translation": "Also, when I speak over in the high school"
    },
    "123": {
        "startTime": 1030.22,
        "endTime": 1037.81,
        "transcript": "Nasaurtuumaita qalarut'laranka ciunerkait qanrutekluki",
        "translation": "I speak to them, including the girls, about what's in their futures"
    },
    "124": {
        "startTime": 1039.49,
        "endTime": 1045.29,
        "transcript": "Nasaurluum uingellerkaa, tan'gaurluum-llu nulirtullerkaa tekilluku.",
        "translation": "Going up to when a girl takes a husband, and a boy takes a wife."
    },
    "125": {
        "startTime": 1045.86,
        "endTime": 1049.27,
        "transcript": "Wii tamaa-i tamakut qanruyutek'lallrenka.",
        "translation": "That is the wisdom passed down to me."
    },
    "126": {
        "startTime": 1050.65,
        "endTime": 1060.76,
        "transcript": "Aklurraanka-gguq makut qelketailkuma, qelkenrilkuma caitelarciqua.",
        "translation": "They said that if I do not take care of what little I have, I will have nothing."
    },
    "127": {
        "startTime": 1061.58,
        "endTime": 1065.06,
        "transcript": "Qelketalriit iciw' maa-i nallunrilketen.",
        "translation": "You know about those who are frugal."
    },
    "128": {
        "startTime": 1066.14,
        "endTime": 1071.31,
        "transcript": "Makut carraat qemagartaqluki pilriani assinrullinilria.",
        "translation": "It better to save these little things."
    },
    "129": {
        "startTime": 1071.38,
        "endTime": 1076.44,
        "transcript": "Caiturpek'nani tua-i teguluki aturaqluki.",
        "translation": "He isn't without anything, able to take and use them."
    },
    "130": {
        "startTime": 1081.77,
        "endTime": 1083.0,
        "transcript": "Cali-qaa?",
        "translation": "Anything else?"
    },
    "131": {
        "startTime": 1084.24,
        "endTime": 1086.74,
        "transcript": "Yaa, apciiqamken allamek uumek.",
        "translation": "Yes, I will ask you this other question."
    },
    "132": {
        "startTime": 1086.74,
        "endTime": 1096.65,
        "transcript": "Lucy, elpeni-qaa maa-i-rpak mat'um nalliini makut ayagyuat, tan'gaurluunge'rmeng nasaurluunge'rmeng-llu",
        "translation": "Lucy, to you, concerning the young people these days, including boys and girls"
    },
    "133": {
        "startTime": 1097.27,
        "endTime": 1102.06,
        "transcript": "Akusrarrngiinartut niicuirusngiinarluteng-llu-qaa?",
        "translation": "Are they becoming more mischievous and disobedient?"
    },
    "134": {
        "startTime": 1102.42,
        "endTime": 1107.05,
        "transcript": "Ilait-wa tuatnangalnguut.",
        "translation": "Some of them seem to do that."
    },
    "135": {
        "startTime": 1108.63,
        "endTime": 1120.73,
        "transcript": "Qalarutengraiceteng-llu atameng wall' aanameng, uum-llu qalarutaqateng, wiinga-ll' qanrutaqamki ukvelkiitaqluteng.",
        "translation": "Even if their fathers or mother speak to them, and when another speaks to them, and when I speak to them, they do not believe."
    },
    "136": {
        "startTime": 1120.73,
        "endTime": 1125.78,
        "transcript": "Qalarucimanrilnguut-wa pilallilriit ayagmek.",
        "translation": "Those who are not taught from the beginning probably do that."
    },
    "137": {
        "startTime": 1126.79,
        "endTime": 1133.87,
        "transcript": "Tuaten tua-i ayuqluteng. Asgurayugnganateng piaqluteng ukveqsuunaki.",
        "translation": "They are like that. They seem to doubt and not believe them."
    },
    "138": {
        "startTime": 1134.52,
        "endTime": 1138.34,
        "transcript": "Piaqluki ayainanratni aturciqniluki.",
        "translation": "We tell them that they will experience them someday."
    },
    "139": {
        "startTime": 1138.55,
        "endTime": 1152.05,
        "transcript": "Cali-llu makut qanruyutet qaneryarat makunun ciulianun qalarucuirutniluta ak'alla'arni.",
        "translation": "And the traditional wisdom and saying, they say that we elders do not speak about them anymore."
    },
    "140": {
        "startTime": 1154.65,
        "endTime": 1163.81,
        "transcript": "Makunek inerquutanek wall'u Bible-aat imaitnek, tamakunek qalarucuirutniluta.",
        "translation": "These admonishments or what's in the Bible, they say we don't speak about them anymore."
    },
    "141": {
        "startTime": 1166.74,
        "endTime": 1175.05,
        "transcript": "Henry, concerning the reason for becoming disobedient, the young people's disobedience",
        "translation": "Henry, concerning the reason for becoming disobedient, the young people's disobedience"
    },
    "142": {
        "startTime": 1176.34,
        "endTime": 1183.87,
        "transcript": "Yuut qanruyutaitnek cagmariinallratnek qaneryarameggnek?",
        "translation": "Because they are losing Yup'ik wisdom and their langauge?"
    },
    "143": {
        "startTime": 1183.87,
        "endTime": 1191.3,
        "transcript": "Iciw' taringyuirulluteng Yugcetun qalartengraata. Tamana-qaa kangingqelarngatuq elpeni tamakunun?",
        "translation": "You know, they don't understand Yup'ik speech anymore. Does that seem to be the reason to you?"
    },
    "144": {
        "startTime": 1192.19,
        "endTime": 1201.49,
        "transcript": "Yaa, makut-wa kinguqliit ukaqvanek ayagluteng, 1950-m kinguanek ayagluteng.",
        "translation": "Yes, at least the recent generation starting after 1950."
    },
    "145": {
        "startTime": 1207.6,
        "endTime": 1215.46,
        "transcript": "Nallunrilkeput Kass'aturrlainaq ukaqvaggun qalartengelriit.",
        "translation": "We know that they've recently started speaking only in English."
    },
    "146": {
        "startTime": 1215.5,
        "endTime": 1228.49,
        "transcript": "Maa-i-llu mat'um nalliini ilait mat'umek alerquutmek, Yuum alerquutainek piirutengluteng, cauciirulluki.",
        "translation": "And these days, some of them don't have instructions, Yup'ik instructions, anymore, with no idea what they are."
    },
    "147": {
        "startTime": 1228.97,
        "endTime": 1241.7,
        "transcript": "Angayuqaita tau͡gaam tamakut, wii umyuarteqlemni angayuqaita Kass'atun qalarut'laqaiceteng mat'um Yuuyaram ayuqucianek assinruyartut.",
        "translation": "But their parents, in my opinion, if the parents speak to the ones who only speak English about the Yup'ik way of life [in English], it would be better."
    },
    "148": {
        "startTime": 1243.31,
        "endTime": 1249.76,
        "transcript": "Makut tau͡gaam Yugtun qantulit taringetuut.",
        "translation": "However, those who speak Yup'ik understand."
    },
    "149": {
        "startTime": 1250.81,
        "endTime": 1259.41,
        "transcript": "Kiani-ll' high school-ami yaaliagnek ayaglua qalarucilaama tamana nallunritaqa.",
        "translation": "And since I've been speaking upriver in the high school starting two years ago, I know that."
    },
    "150": {
        "startTime": 1259.97,
        "endTime": 1262.18,
        "transcript": "Ilait waten qanlartut:",
        "translation": "Some of them say this:"
    },
    "151": {
        "startTime": 1263.06,
        "endTime": 1274.11,
        "transcript": "Yupiam-gguq yuuyaraa, Kass'am-llu qanellra piciunruluni.",
        "translation": "With the Yup'ik way of life, what the West say is more true."
    },
    "152": {
        "startTime": 1276.16,
        "endTime": 1279.71,
        "transcript": "Qanruyutii Kass'am piciunruluni.",
        "translation": "Western wisdom is more true."
    },
    "153": {
        "startTime": 1280.287,
        "endTime": 1283.587,
        "transcript": "Yupiam-gguq tau͡gken qaneryaraa piuvkenani.",
        "translation": "However, they say that Yup'ik wisdom is not."
    },
    "154": {
        "startTime": 1284.392,
        "endTime": 1291.042,
        "transcript": "Tua-i-w' Kass'anun ingluarluteng waten qitevqurluteng piyaurcameng.",
        "translation": "They've started turning to the West because they've started speaking only in English."
    },
    "155": {
        "startTime": 1293.381,
        "endTime": 1297.841,
        "transcript": "Tamaa-i tamana tuaten kiuciryaraqelaraat.",
        "translation": "That is how they answer."
    },
    "156": {
        "startTime": 1300.826,
        "endTime": 1306.596,
        "transcript": "Tua-i-wa. (Ii-i.) Amlleriyugnarqut au͡gkut. (Yaa.) Ii-i.",
        "translation": "That's all. (Okay.) That's probably enough. (Yes.) Okay."
    },
    "157": {
        "startTime": 1306.806,
        "endTime": 1313.561,
        "transcript": "Quyanaqvaa-wa qalartellua. Wiinga waten qalartenritnayuklua pilaryaaqua.",
        "translation": "Thank you for having me speak. I always think that I won't have a chance to speak like this."
    },
    "158": {
        "startTime": 1313.561,
        "endTime": 1316.351,
        "transcript": "Canrituq. Cam iliini cali taiqerciqukut cali.",
        "translation": "That's okay. We'll come again sometime."
    },
    "159": {
        "startTime": 1316.441,
        "endTime": 1317.641,
        "transcript": "Yaa. (Ii-i.)",
        "translation": "Okay. (Okay.)"
    },
    "160": {
        "startTime": 1318.026,
        "endTime": 1320.216,
        "transcript": "Makut, it's done.",
        "translation": "These, it's done."
    },
    "161": {
        "startTime": 1320.376,
        "endTime": 1323.271,
        "transcript": "That was one side of a whole tape or what, one tape?",
        "translation": "That was one side of a whole tape or what, one tape?"
    },
    "162": {
        "startTime": 1323.271,
        "endTime": 1326.331,
        "transcript": "That was the rest of the tape that we put in there.",
        "translation": "That was the rest of the tape that we put in there."
    }
};